export function queueBadgeTone(
  tone: 'danger' | 'warning' | 'success' | 'info' | 'neutral'
) {
  if (tone === 'danger') return 'border-transparent bg-status-red-bg text-status-red'
  if (tone === 'warning')
    return 'border-transparent bg-[#FFF8E8] text-status-amber-text'
  if (tone === 'success')
    return 'border-transparent bg-status-green-bg text-status-green'
  if (tone === 'info') return 'border-transparent bg-primary-subtle text-status-blue-strong'
  return 'border-transparent bg-muted text-muted-foreground'
}

export function actionItemTone(severity: string) {
  if (severity === 'critical') return 'bg-destructive'
  if (severity === 'high') return 'bg-status-orange'
  if (severity === 'medium') return 'bg-amber-400'
  if (severity === 'low') return 'bg-decorative-muted'
  return 'bg-decorative-muted'
}

export function formatTimeAgo(isoString: string): string {
  const date = new Date(isoString)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  if (diffMins < 1) return 'just now'
  if (diffMins < 60) return `${diffMins}m ago`
  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h ago`
  const diffDays = Math.floor(diffHours / 24)
  if (diffDays < 30) return `${diffDays}d ago`
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}

export const TICKET_PROVIDER_MAP: Record<string, { icon: string; label: string }> = {
  github: { icon: 'GitHub', label: 'GitHub' },
  jira: { icon: 'Jira', label: 'Jira' },
  linear: { icon: 'Linear', label: 'Linear' },
}

export function stripMarkdown(text: string): string {
  return text
    .replace(/#{1,6}\s*/g, '')           // headings
    .replace(/\*\*([^*]+)\*\*/g, '$1')   // bold
    .replace(/\*([^*]+)\*/g, '$1')       // italic
    .replace(/`([^`]+)`/g, '$1')         // inline code
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // links
    .replace(/^[-*+]\s+/gm, '· ')        // list items
    .replace(/\n{2,}/g, ' ')             // collapse multiple newlines
    .replace(/\n/g, ' ')                 // single newlines to spaces
    .trim()
}
